<script lang="ts">
	import { goto } from '$app/navigation';
	import { userMarginList } from '$lib/home/userInteract/store';
	import { getDisplayName, getTokenLogo } from '$lib/perps';
	import type { Market, MarketIdentifiers } from '$lib/types/market';
	import { getNumBackInUnits } from '$lib/util/util';
	import BigNumber from 'bignumber.js';
	import { openAdjustMarginModal } from '../../userInteract/userInteract';

	export let market: Market;

	function openMarket() {
		goto(`/perps?market=${market.marketIdentifier}`);
	}
	function getUserMargin(marketId: MarketIdentifiers) {
		if ($userMarginList) {
			// from getUserMargin return the depositedMargin for the markerId
			let depositedMargin = $userMarginList.find((margin) => margin?.marketIdentifier == marketId)
				?.depositedMargin as string;
			if (depositedMargin) return getNumBackInUnits(depositedMargin, 18, 2);
		}
		return '';
	}

	function getUserAccessibleMargin(marketId: MarketIdentifiers) {
		if ($userMarginList) {
			// from getUserMargin return the depositedMargin for the markerId
			let accessibleMargin = $userMarginList.find((margin) => margin?.marketIdentifier == marketId)
				?.accessibleMargin as string;
			if (accessibleMargin) return getNumBackInUnits(accessibleMargin, 18, 2);
		}
		return '';
	}
</script>

{#if !new BigNumber(getUserMargin(market.marketIdentifier)).isZero()}
	<div class="w-full py-2">
		<div
			class="flex gap-3 py-2 rounded-lg squircle-lg bg-fx-gradient-8 cursor-pointer text-fx-grey-300 hover:text-fx-grey-200 hover:bg-fx-grey-700 transform duration-200 ease-out items-center w-full"
		>
			<button class="flex gap-2 justify-center" on:click={openMarket} on:keydown={openMarket}>
				<img
					src={getTokenLogo(market.marketIdentifier)}
					loading="lazy"
					alt="logo"
					class="w-8 h-8 rounded-full"
				/>
				<div class="grid">
					<div class="text-sm rounded-lg squircle-lg font-medium pr-20 whitespace-nowrap">
						{getDisplayName(market.marketIdentifier)}
					</div>
					<div class="flex gap-1">
						<div class="text-fx-grey-200 font-medium text-xs flex gap-1 whitespace-nowrap">
							<span class="text-fx-grey-400"> Margin </span>
							{#if getUserMargin(market.marketIdentifier)}
								{getUserMargin(market.marketIdentifier)}
								{#if new BigNumber(getUserAccessibleMargin(market.marketIdentifier)).isEqualTo(getUserMargin(market.marketIdentifier))}
									<span class="text-fx-grey-400"> (No Position) </span>
								{/if}
							{:else}
								<div
									class="animate-pulse bg-fx-grey-800 h-4 col-span-2 rounded-lg squircle-lg w-6 mx-auto"
								/>
							{/if}
						</div>
					</div>
				</div>
			</button>
			<div class="grow" />
			<div class="text-right">
				<div class="text-fx-grey-200 font-medium text-xs flex gap-1">
					<button
						class="bg-fx-blue text-fx-grey-100 font-semibold text-center py-2 rounded-lg squircle-xl hover:bg-opacity-60 hover:text-fx-grey-200 transition duration-200 cursor-pointer px-4 whitespace-nowrap w-full sm:w-fit"
						on:click={() => {
							openAdjustMarginModal(market.marketIdentifier);
						}}
						on:keydown={() => {
							openAdjustMarginModal(market.marketIdentifier);
						}}
					>
						Adjust
					</button>
				</div>
			</div>
		</div>
	</div>
{/if}
